import React from 'react';
import CONSTANTS from '../../constants';

const ShowMoreButton = (props) => {
	function sendDataToGTM() {
		//event label remonte les données renseignées lors de Click sur CTA "afficher plus de garages à proximité"
		window.dataLayer.push({
			'pageName': "multicréneaux",
			'event': 'uaevent',
			'eventCategory': 'Content',
			'eventAction': "Display::MoreDealers",
			'eventLabel': CONSTANTS.LABELS.multislots_display_more_dealers
		});
		props.onClick();
	}
	return (
		<div tabIndex="0" className="show-more-dealers" onClick={() => sendDataToGTM()} onKeyDown={(e) => e.key === 'Enter' && sendDataToGTM()}>
			<div className="mark-buttons button-bordred--full">
				<span className="button-text">{CONSTANTS.LABELS.multislots_display_more_dealers} </span>
			</div>
		</div>
	)
}

export default ShowMoreButton;
